import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { FiCheck, FiChevronDown, FiChevronUp } from 'react-icons/fi'
import Color from 'color'
import { FullScreenLoader } from '../../../../components/Loader'
import { EventStatus } from '../../../../models/Event'
import StatusColor from '../../../../components/Calendar/BookingCalendar/EventHint/StatusColor'
import EventStatusWrapper from '../../../../components/Calendar/BookingCalendar/EventHint/StatusWrapper'
import ExpandButton from '../../../../components/Calendar/BookingCalendar/EventHint/Button'
import { IWithSize } from '../Calendar'
import { ExapanderWrapper } from './ExpanderWrapper'

const EventStatusExpander = ({
  isOpen,
  toggleOpen,
  statusSettings,
  currentStatus,
  disableExpand = false,
  size = 1,
  updateStatus,
  event,
}: IEventStatusExpanderProps & IWithSize) => {
  const [saving, setSaving] = useState(false)
  const [t] = useTranslation()

  useEffect(() => {
    setSaving(false)
  }, [currentStatus])

  const setActiveStage = stage => () => {
    setSaving(true)
    updateStatus(stage)
  }

  const toggle = () => {
    toggleOpen(!isOpen)
  }

  return (
    <React.Fragment>
      {saving && <FullScreenLoader />}
      <EventStatusWrapper
        size={size}
        onClick={disableExpand ? undefined : toggle}
      >
        <StatusColor
          size={size}
          color={statusSettings.colors[currentStatus].toString()}
        >
          <FiCheck />
        </StatusColor>
        {t(statusSettings.labels[currentStatus])}
        {!disableExpand && (
          <ExpandButton size={size} onClick={toggle}>
            {!isOpen ? (
              <FiChevronDown size={22 * size} />
            ) : (
              <FiChevronUp size={22 * size} />
            )}
          </ExpandButton>
        )}
      </EventStatusWrapper>
      {isOpen && !disableExpand && (
        <ExapanderWrapper>
          {['2', '3', '1', '5', '4']
            .filter(
              status =>
                status !== currentStatus &&
                !(event.airbnbId && event.airbnbId !== '0' && status === '5'),
            )
            .map(status => (
              <EventStatusWrapper
                size={size}
                onClick={setActiveStage(status)}
                isNoPick={true}
                key={status}
              >
                <StatusColor
                  size={size}
                  color={statusSettings.colors[status].toString()}
                >
                  {currentStatus === status ? <FiCheck /> : null}
                </StatusColor>
                {t(statusSettings.labels[status])}
              </EventStatusWrapper>
            ))}
        </ExapanderWrapper>
      )}
    </React.Fragment>
  )
}

export interface IEventStatusExpanderProps {
  statusSettings: {
    colors: { [key: string]: Color }
    labels: { [key: string]: string }
  }
  currentStatus?: EventStatus
  updateStatus?: any
  isOpen: boolean
  toggleOpen: (toggle: boolean) => void
  event: any
  disableExpand?: boolean
}

export default EventStatusExpander
